import { registerTranslationRefresh, t as lnT } from '../i18n';
import {
    FaBagShopping,
    FaBluesky,
    FaBookOpen,
    FaCalendarDays,
    FaCamera,
    FaCirclePlay,
    FaDumbbell,
    FaEnvelopeOpenText,
    FaFacebook,
    FaFilePdf,
    FaFilm,
    FaGamepad,
    FaGithub,
    FaGlobe,
    FaGraduationCap,
    FaInstagram,
    FaLinkedin,
    FaLocationDot,
    FaMicrophone,
    FaMicrophoneLines,
    FaMobileScreenButton,
    FaMusic,
    FaNewspaper,
    FaPinterest,
    FaRedditAlien,
    FaThreads,
    FaTiktok,
    FaTv,
    FaUtensils,
    FaWikipediaW,
    FaXTwitter,
    FaYoutube
} from 'react-icons/fa6';
import { SiSubstack } from 'react-icons/si';
import { getContentPresetColor } from './contentPresetColors';

export const STACK_FOLDER_ID_PREFIX = 'stack-';
export const DEFAULT_SIDEBAR_STACK_IDS = ['instagram-posts', 'tiktok-posts', 'pinterest-pins', 'linkedin-posts', 'x-posts', 'youtube-videos'];

const makeTranslatedSTACK_PRESETS = () => ([
    { id: 'web-pages', label: lnT('common:webPages'), Icon: FaGlobe, filters: { type: ['META_URL'] }, keywords: ['web', 'website', 'web pages'] },
    { id: 'articles', label: lnT('common:articles'), Icon: FaNewspaper, filters: { type: ['META_URL'], entityTypes: ['article'] }, keywords: ['article', 'articles'] },
    { id: 'books', label: lnT('common:books'), Icon: FaBookOpen, filters: { entityTypes: ['book'] }, keywords: ['book', 'books'] },
    { id: 'apps', label: lnT('common:apps'), Icon: FaMobileScreenButton, filters: { entityTypes: ['app'] }, keywords: ['app', 'apps'] },
    { id: 'tv-shows', label: lnT('common:tvShows'), Icon: FaTv, filters: { entityTypes: ['tv_show'] }, keywords: ['tv show', 'tv shows'] },
    { id: 'screenshots', label: lnT('common:screenshots'), Icon: FaCamera, filters: { stackIds: ['screenshots'] }, keywords: ['screenshot', 'screenshots'] },
    { id: 'videos', label: lnT('common:videos'), Icon: FaCirclePlay, filters: { stackIds: ['videos'] }, keywords: ['video', 'videos'] },
    { id: 'youtube-videos', label: lnT('common:youtube'), Icon: FaYoutube, filters: { sourceHosts: ['youtube.com', 'youtu.be'], stackIds: ['videos'] }, keywords: ['youtube', 'yt'] },
    { id: 'instagram-posts', label: lnT('common:instagram'), Icon: FaInstagram, filters: { sourceHosts: ['instagram.com'] }, keywords: ['instagram', 'ig'] },
    { id: 'tiktok-posts', label: lnT('common:tiktok'), Icon: FaTiktok, filters: { sourceHosts: ['tiktok.com'] }, keywords: ['tiktok', 'tik tok'] },
    { id: 'pinterest-pins', label: lnT('common:pinterest'), Icon: FaPinterest, filters: { sourceHosts: ['pinterest.com', 'pin.it'], stackIds: ['pinterest-pins'] }, keywords: ['pinterest', 'pin', 'pins'] },
    { id: 'linkedin-posts', label: lnT('common:linkedin'), Icon: FaLinkedin, filters: { sourceHosts: ['linkedin.com'] }, keywords: ['linkedin', 'linked in'] },
    { id: 'reddit-posts', label: lnT('common:reddit'), Icon: FaRedditAlien, filters: { sourceHosts: ['reddit.com'] }, keywords: ['reddit'] },
    { id: 'facebook-posts', label: lnT('common:facebook'), Icon: FaFacebook, filters: { sourceHosts: ['facebook.com', 'fb.me'] }, keywords: ['facebook', 'fb'] },
    { id: 'bluesky-posts', label: lnT('common:bluesky'), Icon: FaBluesky, filters: { sourceHosts: ['bsky.app', 'bsky.social'] }, keywords: ['bluesky', 'bsky'] },
    { id: 'threads-posts', label: lnT('common:threads'), Icon: FaThreads, filters: { sourceHosts: ['threads.com', 'threads.net'] }, keywords: ['threads'] },
    { id: 'substack-posts', label: lnT('common:substack'), Icon: SiSubstack, filters: { stackIds: ['substack-posts'] }, keywords: ['substack', 'newsletter'] },
    { id: 'x-posts', label: lnT('common:x'), Icon: FaXTwitter, filters: { stackIds: ['x-posts'] }, keywords: ['x', 'twitter', 'tweet', 'tweets'] },
    { id: 'x-articles', label: lnT('common:xArticles'), Icon: FaXTwitter, filters: { stackIds: ['articles'] }, keywords: ['x article', 'twitter article', 'x articles'] },
    { id: 'pdf-docs', label: lnT('common:pdfs'), Icon: FaFilePdf, filters: { type: ['PDF'] }, keywords: ['pdf', 'document', 'documents'] },
    { id: 'products', label: lnT('common:products'), Icon: FaBagShopping, filters: { entityTypes: ['product'] }, keywords: ['product', 'products', 'shop'] },
    { id: 'games', label: lnT('common:games'), Icon: FaGamepad, filters: { entityTypes: ['game'] }, keywords: ['game', 'games', 'gaming', 'steam', 'playstation', 'xbox', 'nintendo'] },
    { id: 'movies', label: lnT('common:movies'), Icon: FaFilm, filters: { entityTypes: ['movie'] }, keywords: ['movie', 'movies', 'film'] },
    { id: 'recipes', label: lnT('common:recipes'), Icon: FaUtensils, filters: { entityTypes: ['recipe'] }, keywords: ['recipe', 'recipes'] },
    { id: 'music', label: lnT('common:music'), Icon: FaMusic, filters: { entityTypes: ['music'] }, keywords: ['music', 'song', 'songs', 'track', 'tracks'] },
    { id: 'voice-notes', label: lnT('common:voiceNotes'), Icon: FaMicrophoneLines, filters: { stackIds: ['voice-notes'] }, keywords: ['voice', 'voice note', 'voice notes', 'recording', 'recordings'] },
    { id: 'repositories', label: lnT('common:repositories'), Icon: FaGithub, filters: { sourceHosts: ['github.com'] }, keywords: ['repo', 'repository', 'repositories', 'github'] },
    { id: 'wikipedia', label: lnT('common:wikipedia'), Icon: FaWikipediaW, filters: { sourceHosts: ['wikipedia.org'] }, keywords: ['wikipedia', 'wiki'] },
    { id: 'newsletters', label: lnT('common:newsletters'), Icon: FaEnvelopeOpenText, filters: { stackIds: ['newsletters'] }, keywords: ['newsletter', 'newsletters', 'substack', 'beehiiv'] },
    { id: 'podcasts', label: lnT('common:podcasts'), Icon: FaMicrophone, filters: { entityTypes: ['podcast'] }, keywords: ['podcast', 'podcasts'] },
    { id: 'places', label: lnT('common:places'), Icon: FaLocationDot, filters: { entityTypes: ['place'] }, keywords: ['place', 'places', 'location', 'restaurant', 'hotel', 'maps', 'google maps', 'apple maps'] },
    { id: 'workouts', label: lnT('common:workouts'), Icon: FaDumbbell, filters: { entityTypes: ['workout'] }, keywords: ['workout', 'workouts', 'fitness', 'exercise', 'gym'] },
    { id: 'events', label: lnT('common:events'), Icon: FaCalendarDays, filters: { entityTypes: ['event'] }, keywords: ['event', 'events', 'concert', 'conference', 'show'] },
    { id: 'tutorials', label: lnT('common:tutorials'), Icon: FaGraduationCap, filters: { entityTypes: ['tutorial'] }, keywords: ['tutorial', 'tutorials', 'how to', 'course', 'guide'] }
].map(preset => ({
    ...preset,
    iconColor: getContentPresetColor('stack', preset.id),
})));
let STACK_PRESETS = makeTranslatedSTACK_PRESETS();
registerTranslationRefresh(() => { STACK_PRESETS = makeTranslatedSTACK_PRESETS(); });

const makeTranslatedSTACK_SEARCH_PRESETS = () => ([...STACK_PRESETS].sort((left, right) =>
    left.label.localeCompare(right.label)
));
export let STACK_SEARCH_PRESETS = makeTranslatedSTACK_SEARCH_PRESETS();
registerTranslationRefresh(() => { STACK_SEARCH_PRESETS = makeTranslatedSTACK_SEARCH_PRESETS(); });

export const getStackPreset = stackId =>
    STACK_SEARCH_PRESETS.find(preset => preset.id === stackId);

export const createStackFolder = preset => ({
    id: `${STACK_FOLDER_ID_PREFIX}${preset.id}`,
    title: preset.label,
    stackPresetId: preset.id,
    isStack: true
});

export const getStackFolderFromSlug = slug => {
    if (!String(slug || '').startsWith(STACK_FOLDER_ID_PREFIX)) return null;
    const preset = getStackPreset(String(slug).slice(STACK_FOLDER_ID_PREFIX.length));
    return preset ? createStackFolder(preset) : null;
};
